<template>
    <panel-template
        :have-padding="$route.name === 'products.units' ? false : true"
    >
        <template #bradcrumbs>
            <ui-breadcrumbs design="full" :container="false">
                <template #left>
                    <span v-if="isForTracker">
                        <span @click="goIntegrations">Integrações</span>
                        <span> &#8226; Captura de Formulários </span>
                    </span>

                    <span v-if="isFacebook">
                        <span @click="goIntegrations">Integrações</span>
                        <span>&#8226; Integração Facebook</span>
                    </span>

                    <span v-if="isErp">
                        <span>Integração ERP </span>
                        <span>&#8226; Bem vindo</span>
                    </span>

                    <span v-if="isAddIntegration">
                        <span>Integração ERP </span>
                        <span>&#8226; Nova Integração</span>
                    </span>

                    <span v-if="isDataAvailability">
                        <router-link :to="{ name: 'marketing.integrations.erp' }">
                            <span>Integração ERP </span>
                        </router-link>
                        <span>&#8226; Nova Integração </span>
                        <span>&#8226; {{ integration ? integration.type : '' }} </span>
                    </span>

                    <span v-if="isUnits">
                        <router-link :to="{ name: 'marketing.integrations.erp.products' }">
                            <span>Empreendimentos</span>
                        </router-link>
                        <span> &#8226; {{ product ? product.name : '-' }}</span>
                        <span> &#8226; Lista de Unidades</span>
                    </span>

                    <span v-if="isProposalMapsFields">
                        <router-link :to="{ name: 'marketing.integrations.erp' }">
                            <span>Integração ERP</span>
                        </router-link>
                        <span> &#8226; Mapear Campos para Proposta</span>
                    </span>
                </template>
            </ui-breadcrumbs>
        </template>

        <template #content>
            <router-view />
        </template>
    </panel-template>
</template>

<script>
import { uiBreadcrumbs } from '@/components/ui'
import PanelTemplate from '@/templates/page-panel-center'

import helpers from '@/mixins/helpers'
import { mapGetters } from 'vuex'

export default {
	name: 'ui-marketing-integrations',

	components: {
		PanelTemplate,
		uiBreadcrumbs,
	},

	mixins: [helpers],

	computed: {
		...mapGetters('ERP', {
			integration: 'getSelected',
			product: 'getProduct'
		}),
		isFacebook() {
			return (
				window.location.pathname == '/v2-dev/marketing/integracoes/facebook' ||
				window.location.pathname == '/v2/marketing/integracoes/facebook'
			)
		},
		isForTracker() {
			return (
				window.location.pathname == '/v2-dev/marketing/integracoes/formtracker' ||
				window.location.pathname == '/v2/marketing/integracoes/formtracker'
			)
		},
		isErp() {
			return [
				'marketing.integrations.erp',
				'marketing.integrations.erp.products',
				'marketing.integrations.erp.integrations',
			].includes(this.$route.name)
		},
		isAddIntegration() {
			return ['marketing.integrations.erp.add'].includes(this.$route.name)
		},
		isDataAvailability() {
			return ['marketing.integrations.erp.availability'].includes(this.$route.name)
		},
		isUnits() {
			return ['products.units'].includes(this.$route.name)
		},
		isProposalMapsFields() {
			return ['marketing.integrations.erp.map_proposal'].includes(this.$route.name)
		}
	},

	methods: {
		goIntegrations() {
			this.oldPanelLinkButton('configuracao/apps')
		},
	},
}
</script>

<style lang="stylus" scoped>
@import './styles.styl';
</style>
